module.exports = __webpack_public_path__ + "static/media/29ADMSPC1.68858676.jpg";